var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"post-category",style:({ backgroundColor: _vm.category.color })},[_c('i',{class:_vm.category.icon}),_vm._v(_vm._s(_vm.category.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }